<!-- Chapter Text -->

<!-- Content -->
<div class="mdsf-container js-modal-content-container">
  <main class="mdsf-chapter-container">
    <aside class="sidebar">
      <medsurf-sidebar [showCurrentSubject]="false" class="d-none d-md-block"></medsurf-sidebar>
    </aside>
    <article class="article">
      <!-- Vocabulary -->
      @if ((nodeSharedFacade.currentSelectedChapterPageType$ | async) === pageType.enum.Vocabulary) {
        <medsurf-vocabulary
        [vocabulary]="(nodeSharedFacade.currentSelectedChapterPage$ | async)"></medsurf-vocabulary>
      }

      <!-- Quiz Start -->
      @if ((nodeSharedFacade.currentSelectedChapterPageType$ | async) === pageType.enum.QuizStart && (nodeSharedFacade.isTrainingResult$ | async) === false) {
        <medsurf-quiz-start></medsurf-quiz-start>
      }

      <!-- Quiz End -->
      @if ((nodeSharedFacade.isTrainingResult$ | async)) {
        <medsurf-quiz-end></medsurf-quiz-end>
      }

      <!-- Other -->
      @if ((nodeSharedFacade.currentSelectedChapterPageType$ | async) !== pageType.enum.Vocabulary
        && (nodeSharedFacade.currentSelectedChapterPageType$ | async) !== pageType.enum.QuizStart
        && (nodeSharedFacade.isTrainingResult$ | async) === false) {
        @if ((nodeSharedFacade.currentSelectedBlockPage$ | async); as blockPage) {
          @if (blockPage.type === 'Grid') {
            <medsurf-grid></medsurf-grid>
          }
          @if (blockPage.type === 'Case') {
            <medsurf-case-start></medsurf-case-start>
          }
        } @else {
          <medsurf-chapter-text></medsurf-chapter-text>
        }
      }
    </article>
  </main>

  <!-- Footer -->
  <medsurf-footer class="d-none d-md-inline"
    [links]="footerLinks"
    align="left">
  </medsurf-footer>
</div>
